module.exports = __webpack_public_path__ + "static/mathallen-small.1f644170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/graphics/mathallen-small.jpg
// module id = 332
// module chunks = 263791100135453